import { paymentClient } from "@core/clients";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type UseGetPaymentQueryProps = {
  paymentId: string;
  options?: UseQueryOptions<any, any, any, any>;
};

const useGetPaymentQuery = ({ paymentId, options }: UseGetPaymentQueryProps) => {
  return useQuery(["payment", paymentId], async () => await paymentClient.getYooKassaPayment(paymentId), {
    ...options,
  });
};

export default useGetPaymentQuery;
